<template>
  <div>
    <div>
      <h1>Welcome to the Admin page where you are granted powers and declared a iBegician!</h1>
    </div>
    <div>
      <div>
        <h3>
          Generate Character Model and Animations
        </h3>
        <p>Clicking the following button will generate character models and store them in Google Storage.</p>
        <button @click="generateCharacterModelAndAnimations">Generate Character Model and Animations</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    generateCharacterModelAndAnimations () {
      // TODO: FILL THIS IN REF: https://gist.github.com/gnuton/ec2c3c2097f7aeaea8bb7d1256e4b212
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/Admin.vue